import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Includes/Footer";
import Header from "../Includes/Header";
import { StoreContext } from "../../store/Store";
import { toast } from "sonner";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";

const SignIn = () => {
  const [activeStep, setActiveStep] = useState("step1");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const emailInputRef = useRef(null);

  useEffect(() => {
    emailInputRef.current?.focus();
  }, []);

  const { login } = useContext(StoreContext);
  const navigate = useNavigate();

  const handleLoginClick = () => setActiveStep("step1");
  const handleRegisterClick = () => setActiveStep("step2");

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email || !password) {
      toast.error("All fields are required!");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      toast.error("Please enter a valid email address!");
      return;
    }
    const userData = {
      email,
      password,
      login: 1
    };
    await login(userData, navigate);
    // setEmail("");
    // setPassword("");
  }

  return (
    <>
      <Header />
      <div id="loader_form">
        <div data-loader="circle-side-2"></div>
      </div>

      <div
        className="d-flex flex-column bg-white"
        style={{ minHeight: "calc(100vh - 140px)" }}
      >
        {/* Form Content */}
        <div className="container-fluid d-flex flex-column my-auto">
          <div id="wizard_container" className="container">
            <div id="top-wizard">
              <div id="progressbar"></div>
            </div>
            <form id="wrapped" onSubmit={handleSubmit}>
              <input id="website" name="website" type="text" value="" hidden />

              <div id="middle-wizard" className="container">
                <div className="row justify-content-center algn-items-center">
                  <div className="col-md-12 col-lg-8">
                    {/* Step 1 - Address */}
                    <div
                      className={`step1 ${
                        activeStep === "step1" ? "" : "d-none"
                      }`}
                    >
                      <div className="question_title text-center mb-32">
                        <h4>Enter your details</h4>
                        <p style={{ fontSize: "1rem" }}>
                          Please enter the login details below
                        </p>
                      </div>
                      <div className="">
                        <div className="">
                          <div className="mb-3 form-floating">
                            <input
                              type="email"
                              name="email"
                              id="lastname"
                              value={email}
                              ref={emailInputRef}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="Enter your email"
                              required
                            />
                            <label htmlFor="Email">Email</label>
                          </div>
                          <div
                            className="mb-3 form-floating"
                            style={{ position: "relative" }}
                          >
                            <input
                              type={showPassword ? "text" : "password"}
                              name="password"
                              id="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              className="form-control"
                              placeholder="Password"
                              required
                            />
                            <label htmlFor="password">Password</label>

                            <button
                              type="button"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "5px",
                                fontSize: "18px",
                                color: "#555",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              aria-label={
                                showPassword ? "Hide password" : "Show password"
                              }
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="bottom-wizard"
                        className="d-flex justify-content-center align-items-center"
                      >
                        <button
                          type="submit"
                          name="forward"
                          className="text-center"
                          style={{
                            backgroundColor: "#3a80c2",
                            padding: "7px 30px",
                            boxShadow: "#475e63 0px 0px 0px 0px",
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#fff",
                            minWidth: "140px",
                          }}
                        >
                          Login
                        </button>
                      </div>

                      <div className="text-center">
                        {/* <p>
                          Don't have an account?{" "}
                          <Link
                            className="register-link text-dark fw-semibold link-underline-dar"
                            onClick={handleRegisterClick}
                            // to="#"
                          >
                            Register
                          </Link>
                        </p> */}
                      </div>
                    </div>

                    {/* Step 2 - Personal Details */}
                    {/* <div
                      className={`step2 ${
                        activeStep === "step2" ? "" : "d-none"
                      }`}
                    >
                      <div className="question_title">
                        <h3>Enter your details</h3>
                        <p>Please enter the register details below</p>
                      </div>

                      <div className="">
                        <div className="mb-3 form-floating">
                          <input
                            type="text"
                            name="firstname"
                            id="firstname"
                            className="form-control"
                            placeholder="First Name"
                            required
                          />
                          <label htmlFor="User Name">User Name</label>
                        </div>
                        <div className="mb-3 form-floating">
                          <input
                            type="text"
                            name="lastname"
                            id="lastname"
                            className="form-control"
                            placeholder="Last Name"
                            required
                          />
                          <label htmlFor="Email">Email</label>
                        </div>
                        <div className="mb-3 form-floating">
                          <input
                            type="email"
                            name="email"
                            id="email"
                            className="form-control"
                            placeholder="Your Email"
                            required
                          />
                          <label htmlFor="Password">Password</label>
                        </div>
                      </div>

                      <div id="bottom-wizard">
                        <button
                          type="button"
                          name="backward"
                          className="backward btn_1 d-none"
                        >
                          Backward
                        </button>
                        <button
                          type="button"
                          name="forward"
                          className="forward btn_1 ciao"
                          style={{
                            backgroundColor: "#0bb2cf",
                            boxShadow: "#475e63 0px 0px 0px 0px",
                          }}
                        >
                          Register
                        </button>
                        <button
                          type="submit"
                          name="process"
                          className="submit btn_1 d-none"
                        >
                          Submit
                        </button>
                      </div>

                      <div className="text-center">
                        <p>
                          Already have an account{" "}
                          <Link
                            className="login-link text-dark fw-semibold link-underline-dar"
                            onClick={handleLoginClick}
                          >
                            Login
                          </Link>
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignIn;
